const duplicate = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M10.55 8V6.55H12v-1.1h-1.45V4h-1.1v1.45H8v1.1h1.45V8zM4 0v12h12V0zm10.5 10.5h-9v-9h9zM0 2h1.65v12.35H14V16H0z"/></svg>',
};

export { duplicate as default };
